import React, { useEffect, useRef, useState } from "react";
import SplitPane from "react-split-pane";
import Pane from "react-split-pane/lib/Pane";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "slices/dictionarySearch/actions/categories";
import { folderBy } from "layout/dictionarySearch/constants";
import Categories from "layout/dictionarySearch/folder/byDocument/categories";
import ContentPanel, {
  getDocItemsArrayList,
} from "layout/dictionarySearch/content/ContentPanel";

const ByDocument = () => {
  const dispatch = useDispatch();
  const categoriesListRef = useRef();
  const [categoriesSize, setCategoriesSize] = useState("50%");
  const documents = useSelector((state) => state.dictionarySearch.documents);

  const handleDragRelease = () => {
    if (categoriesListRef && categoriesListRef.current) {
      setCategoriesSize(categoriesListRef.current.props.size);
    }
  };

  const styles = {
    background: "transparent",
    width: "1px",
    cursor: "col-resize",
    height: "100%",
    paddingRight: "2px",
    borderRight: "transparent 4px solid",
    borderLeft: "transparent 4px solid",
    margin: "0 -5px",
    zIndex: "1",
  };

  useEffect(() => {
    dispatch(fetchCategories(folderBy.document));
    window.addEventListener("mouseup", handleDragRelease);
    return () => {
      window.removeEventListener("mouseup", handleDragRelease);
    };
  }, [dispatch]);

  return (
    <SplitPane
      className="dictionary_search__folder__by_document"
      style={{ position: "relative", overflow: "hidden" }}
      resizerStyle={styles}
      split="vertical"
    >
      <Pane
        ref={categoriesListRef}
        minSize="400px"
        initialSize={categoriesSize}
        className="dictionary_search__folder__by_document-left"
      >
        <Categories />
      </Pane>
      <Pane
        minSize="200px"
        className="dictionary_search__folder__by_document-right"
      >
        <ContentPanel docItemsArray={getDocItemsArrayList(documents)} />
      </Pane>
    </SplitPane>
  );
};

export default ByDocument;
